module.exports = __webpack_public_path__ + "img/_ic_star_25.8be99cd3.svg";